import React from 'react';

const TrialDetails = ({ trial }) => {
  const defaultTrial = {
    id: "NCT04532723",
    title: "Phase II Study of Novel IO Combination",
    eligibility: [
      "Stage III/IV NSCLC",
      "PDL1 > 50%",
      "No prior immunotherapy",
      "ECOG 0-1"
    ],
    exclusions: [
      "Autoimmune disease",
      "Active brain metastases",
      "Significant cardiac disease"
    ],
    contact: {
      name: "Dr. Sarah Chen",
      phone: "(555) 123-4567",
      email: "trial@memorial.org"
    }
  };
  
  const trialData = trial || defaultTrial;
  
  return (
    <div className="bg-gray-200 p-4 h-full">
      <h2 className="text-lg font-medium text-gray-700 mb-2">Selected Trial:</h2>
      
      <h3 className="text-xl font-medium text-gray-800 mb-4">{trialData.id}</h3>
      <p className="mb-4">"{trialData.title}"</p>
      
      <div className="mb-4">
        <h4 className="font-medium text-gray-700 mb-1">Key Eligibility:</h4>
        <ul className="space-y-1 mb-4">
          {trialData.eligibility.map((criterion, index) => (
            <li key={index} className="text-gray-700 flex items-start">
              <span className="mr-1">•</span> {criterion}
            </li>
          ))}
        </ul>
      </div>
      
      <div className="mb-4">
        <h4 className="font-medium text-gray-700 mb-1">Exclusions:</h4>
        <ul className="space-y-1 mb-4">
          {trialData.exclusions.map((exclusion, index) => (
            <li key={index} className="text-gray-700 flex items-start">
              <span className="mr-1">•</span> {exclusion}
            </li>
          ))}
        </ul>
      </div>
      
      <div className="mb-4">
        <h4 className="font-medium text-gray-700 mb-1">Contact:</h4>
        <p>{trialData.contact.name}</p>
        <p>{trialData.contact.phone}</p>
        <p>{trialData.contact.email}</p>
      </div>
      
      <button className="w-full py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mt-2">
        Contact Coordinator
      </button>
    </div>
  );
};

export default TrialDetails;